import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Grid,
  CircularProgress
} from '@material-ui/core';
import FacebookIcon from 'src/icons/Facebook';
import LoginStyle from 'src/styles/LoginStyle';
import validations from 'src/utils/validations';
import firebase from 'firebase/app';
import 'firebase/auth';
import { useState } from 'react';

const Login = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const onLoginClick = (values) => {
    setLoading(true);
    firebase.auth().signInWithEmailAndPassword(values.email, values.password)
      .then((userCredential) => {
        const { user } = userCredential;
        console.log(user);
        setLoading(false);
        navigate('/app/events', { replace: true });
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage = error.message;
        alert(errorMessage);
      });
  };

  return (
    <>
      <Helmet>
        <title>Login | Lead Generation</title>
      </Helmet>
      <Box
        sx={LoginStyle.box}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: 'admin@admin.com',
              password: 'admin@123'
            }}
            validationSchema={validations.login}
            onSubmit={(values) => {
              onLoginClick(values);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={20}
                  direction="column"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item xs={3}>
                    <FacebookIcon style={LoginStyle.logo} />
                  </Grid>
                </Grid>
                <Box sx={{ mb: 3 }}>
                  <Typography color="textPrimary" align="center" variant="h2">
                    App Name
                  </Typography>
                </Box>
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email Address"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Password"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Sign in now
                  </Button>
                </Box>
                {/* <Typography
                  color="textSecondary"
                  variant="body1"
                >
                  Don&apos;t have an account?
                  {' '}
                  <Link
                    component={RouterLink}
                    to="/register"
                    variant="h6"
                  >
                    Sign up
                  </Link>
                </Typography> */}
              </form>
            )}
          </Formik>
          <div style={LoginStyle.progressContainer}>
            {isLoading && <CircularProgress style={{ alignSelf: 'center' }} />}
          </div>
        </Container>
      </Box>
    </>
  );
};

export default Login;
